export const environment = {
    production: true,
    debug: false,
    theme: null,
    apiUrl: 'https://api.begaym.com',
    websiteUrl: 'https://www.begaym.com',
    mercureUrl: 'https://mercure.begaym.com',
    sentryUrl: 'https://520de0777199eba4b57bfc07cb50b806@o4504169989210112.ingest.sentry.io/4506279864565760',
    mapboxUrl: 'https://api.mapbox.com/geocoding/v5',
    mapboxToken: 'pk.eyJ1IjoiYmVnYXltLTEzIiwiYSI6ImNsYW1lN21raTBmYzQzeW9icmd6b255anYifQ.y-Bt91gQlZtxREtc4109rA',
    axeptioID: '62039f9eb7f4b54639bd8a2a',
    gaID: 'GTM-THL6W6J',
    fbID: '1214421753845834'
};
